<template>
    <TextField
        :id="id"
        ref="field"
        v-model="inputVal"
        v-bind="$attrs"
        inputmode="numeric"
        :mask="phoneMask"
        :required="required"
        :validations="validations"
        :disabled="disabled"
    >
        <template #label><slot name="label">{{$attrs.label}}</slot></template>

        <template #message="messageProps">
            <slot name="message" :message="messageProps.message" />
        </template>
    </TextField>
</template>
<script>
    import masks from "@/util/mask"
    import FieldProxyMixin from "@/components/form/FieldProxyMixin"
    import { validPhoneNumber } from "@/util/validation"

    export default {
        mixins: [FieldProxyMixin],

        inheritAttrs: true,

        data() {
            return {
                phoneMask: masks.phone,
            }
        },

        methods: {
            validationSource: function(target, field) {
                field.applyValidator(target, validPhoneNumber.id, validPhoneNumber)

                field.applyValidator(target, 'remotePhone', (value) => {
                    if (!value) return true
                    if (!this.getRemoteValidator()) return true
                    return this.getRemoteValidator().validate('phone', { phoneNumber: value })
                        .then(({ valid }) => valid)
                })
            },
        },
    }
</script>
